/** The key used by the applicationSubmissions reducer to store the state of the last application
 * form */
export const LAST_APPLICATION = 'last_application';

// The name of the query string parameters used when filtering job listings
export const QUERY_STRING_PARAM_KEYWORD = 'q';
export const QUERY_STRING_PARAM_LOCATION = 'loc';
export const QUERY_STRING_PARAM_JOB_FUNCTION = 'cat';
export const QUERY_STRING_PARAM_PLACEMENT_TYPE = 'type';
